import classNames from "classnames";
import { CSSProperties } from "glamor";
import * as React from "react";
import { maxDaysForActiveGoal } from "source/app/presentation/MainPanel/Goals/GoalCards/Helpers/GoalCardsConstants";
import { IGoalDaysLeftOptions } from "source/app/presentation/MainPanel/Goals/GoalCards/Helpers/IGoalDaysLeftOptions";
import { Style, StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { MathUtils } from "source/app/services/Math/MathUtils";

export function GoalDaysLeft({
    goal,
    daysleft,
    styles,
    realMomentum,
}: IGoalDaysLeftOptions) {
    const rotation: CSSProperties = {
        transform: `rotate(${MathUtils.RandomNumberBetween(-15, 15)}deg)`,
    };

    const isTrackingOff = daysleft > maxDaysForActiveGoal;
    const textToDisplay = isTrackingOff ? "-" : realMomentum;

    const goodStreakStyleClass = StyleClass(`goodStreakValue`, {
        color: "white",
        background: "green",
        opacity: 0.7,
    });

    const badStreakStyleClass = StyleClass(`badStreakValue`, {
        color: "white",
        background: `rgb(105 105 105)`,
    });

    return (
        <span
            id="goalDaysLeft"
            className={classNames([styles.goalDaysLeft], {
                [goodStreakStyleClass]: realMomentum >= 0,
                [badStreakStyleClass]: realMomentum < 0,
                [styles.goalDaysLeft_Untracked]: isTrackingOff,
            })}
            {...Style(`goalDaysLeft_rotation_${goal.name}`, rotation)}
        >
            {textToDisplay}
        </span>
    );
}
